import React, { useState, useEffect, useRef, Fragment } from "react";

import ReactQuill from 'react-quill';

import GalleryModal from "../Gallery/GalleryModal";
const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "align",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video"
];
const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ 'color': [] }, { 'background': [] }],
    [{ align: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};

// import axios from 'axios';
// imagePicker: Upload, media, normal
const ImageEditor = (props) => {
  const [openingModal, setOpeningModal] = useState(false);
  const reactQuillRef = useRef();
  const { imagePicker = 'upload', onChange, ...restProps} = props;
  const handleSelect = (images) => {
    const quillRef = reactQuillRef.current.getEditor();
    const range = quillRef.getSelection(true);
    const position = range ? range.index : 0;
    const imageUrl = images ? images[0]?.image_url : null;

    if(imageUrl) {
      quillRef.editor.insertEmbed(position, 'image', imageUrl);
      onChange(quillRef.root.getInnerHTML());
    }
    setOpeningModal(false);

  }
  const handleChange = (value) => {
    onChange(value)
  }
  const imageHandler = (e) => {
    setOpeningModal(true);

    return false;
   
  };
 

  return (
    <Fragment>
      <button type="button" onClick={imageHandler}>
        Add Image
      </button>
    <ReactQuill 
      {...restProps}
      onChange={handleChange}
      ref={reactQuillRef}
      modules={quillModules}
      theme="snow"
      formats={quillFormats}
      onEditorChange={e => console.log('onEditorChange', e)}
    />
    <GalleryModal
      maxNumberOfFiles={1}
      isOpen={!!openingModal}
      onCancel={(e) => setOpeningModal(null)}
      onSelectPhoto={handleSelect}
      
    />
  </Fragment>
  );
};

export default ImageEditor;